<template>
  <DataList
    title="Проекти"
    resource="projects"
    :columns="columns"
    :disable-adding="true"
    :filter="filter"
    :is-header-filter="true"
    :get-items-fn="getProjects"
    :search-label="'Пошук за назвою проекта'"
  >
    <template v-slot:action-buttons>
      <DownloadFile
        :location="`projects/rpc/export-to-excel`"
        filename="Проекти"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
      />
    </template>
    <template v-slot:header-filters>
      <v-row>
        <v-col
          md="6"
          sm="6"
          class="pr-0"
        >
          <CustomTextField
            v-model="category"
            label="Категория"
            append-icon="search"
            class="my-1 mr-1 ml-2"
          />
        </v-col>
        <v-col
          md="6"
          sm="6"
          class="pl-0"
        >
          <ClientSelect
            v-model="clientId"
            label="Клієнт"
            class="ma-1"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import * as projectsApi from "../../../backend/projectsApi.js";
import DownloadFile from "../../../components/DowloadFile.vue";
import ClientSelect from "../../../components/selects/ClientSelect.vue";
import CustomTextField from "../../../components/CustomTextField.vue";

export default {
  components: {
    DownloadFile,
    ClientSelect,
    CustomTextField,
  },
  data: () => ({
    columns: [
      { title: "id", name: "id", dataPath: "id" },
      { title: "Найменування", name: "title", rowType: "wide" },
      { title: "Категория", name: "category", rowType: "wide" },
      { title: "Клієнт", name: "client", dataPath: "client.title", rowType: "wide" },
      { title: "Fix Price", name: "fixPrice", type: "bool" },
    ],
    clientId: null,
    category: null,
  }),
  computed: {
    filter() {
      return {
        client: {
          id: this.clientId ? this.clientId.id : "",
          title: this.clientId ? this.clientId.title : "",
          category: this.category ? this.category : "",
        },
      };
    },
  },
  methods: {
    getProjects(...args) {
      return projectsApi.getProjects(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
